import React from 'react';
import { shortenHash } from '@soundxyz/utils/const';
import { FollowButton } from '@components/basics/FollowButton';
import { Avatar } from '@components/basics/Images/Avatar';
import { useChannelCurators } from '../useChannelCurators';

const CURATORS_LIMIT = 5;

export function ChannelCurators({ channelId }: { channelId: string }) {
  const { channelCurators } = useChannelCurators({
    channelId,
    limit: CURATORS_LIMIT,
    sortByRole: 'OWNER',
  });

  return (
    <div className="flex flex-col gap-4">
      <h2 className="font-title text-title-s font-medium text-base800">Curators</h2>

      {channelCurators.map(curator => {
        return (
          <div key={curator.id} className="flex w-full items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 flex-shrink-0">
                <Avatar
                  size={40}
                  src={curator.user.avatar?.url}
                  walletAddress={curator.user.publicAddress}
                  webappUri={curator.user.artist?.webappUri ?? curator.user.webappUri}
                  borderRadius={999}
                />
              </div>

              <div className="flex w-full flex-col gap-[2px]">
                <span className="font-title text-[13px] font-medium leading-[120%] text-base600">
                  {curator.user.artist?.name ??
                    curator.user.displayName ??
                    shortenHash(curator.user.publicAddress)}
                </span>
                <span className="font-base text-[11px] font-medium leading-[100%] text-base500">
                  {curator.role === 'MODERATOR' ? 'Moderator' : 'Admin'}
                </span>
              </div>
            </div>
            <div>
              <FollowButton
                artistId={curator.user.artist?.id}
                userId={curator.user.id}
                variant="primary"
                sourceLocation="Channel Page"
                size="XS"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
